<div class="card">
  <div class="card-body padding-all-0px">
    <div class="row margin-right-0px margin-left-0px margin-top-5px">
      <div class="col-md-9 margin-left-15px padding-right-0px padding-left-3px ">
        <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
      </div>
      <div class="col-md-2">
        <button type="button" (click)="AddEventDetails()" class="btn btn-ivf-new  btn-sm background-primary border-all-secondary" tooltip="Add"><i class="fas fa-plus nav-link-hand"></i></button>
      </div>
    </div>
    <div class="chatsd product-chart-wrapper product-chat-width-testnew agreement-chart-wrapper ps overflow-x-hidden padding-lrt " data-ps-id="dfsfsde">

      <div class="row margin-top-3px margin-left-0px" *ngFor="let l of pdata">
        <div class="col-md-12">

          <div class="row">
            <div class="col-md-11 padding-left-19px">


              <div class="row">
                <div class="col-md-5 padding-right-0px padding-left-17px">
                  <div class="display-inline">
                    <label class="margin-bottom-0px font-size-12px color-Assign">{{l.ActivityTypeName}}</label>
                  </div>                  
                </div>
                <div class="col-md-7  padding-right-5px padding-left-0px text-align-right">
                  <div class="display-inline" *canUserAccess="['EditCycleActivity']">
                    <a class="nav-link-hand education-navlink" tooltip="Edit" (click)="EditCycleActivity(l)">
                      <span class="badge font-size-12px"><i class="fas fa-pencil-alt"></i></span>
                    </a>
                  </div>
                  <div class="display-inline padding-right-5px" *canUserAccess="['DeleteCycleActivity']">
                    <a class="nav-link-hand font-size-12px color-Rejected" title="Remove" (click)="DeleteCycleActivity(l)">
                      <i class="far fa-trash-alt nav-link-hand"></i>
                    </a>
                  </div>
                  <div class="display-inline">
                    <label class="font-size-12px margin-bottom-0px date-color-contracts">{{l.ActivityDate | date:'MMM-dd-yyyy'}}</label>
                    <!--<label class="font-size-12px margin-bottom-0px date-color-contracts margin-left-3px">{{l.ActivityDate | date: 'mediumTime'}}</label>-->
                  </div> 
                  </div>
                  <!--<div class="col-md-3 padding-left-0px padding-right-0px">
    <label class="margin-bottom-0px margin-left-5px font-size-12px color-secondary  padding-left-0px">Scans</label>
  </div>-->
                  <!--<div class="col-md-8 text-align-right">

  </div>-->
                </div>


              <div class="message-sender2">

                <div class="row border-left-8px-cycle margin-left-0px">
                  <div class="col-md-12 margin-top-4px  font-size-13px text-align-justify">
                    <div class="row ">
                      <div class="col-md-8 padding-left-5px padding-right-0px">
                        <label class="margin-bottom-0px">{{l.ActivityName}}</label>
                      </div>
                      <div class="col-md-4 padding-left-0px padding-right-7px" id="edit-link" hidden>
                        <a class="nav-link-hand float-right margin-left-7px display-edit" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                        <a class="nav-link-hand   color-Assign float-right margin-left-7px display-edit" title="Edit">
                          <i class="fas fa-pencil-alt nav-link-hand  "></i>
                        </a>
                        <a class="nav-link-hand   color-Assign float-right display-edit" title="Detail">
                          <i class="fas fa-list nav-link-hand"></i>
                        </a>
                      </div>
                    </div>

                    <div class="row ">
                      <div class="col-md-12 padding-left-5px">
                        <label class="margin-bottom-0px">{{l.Remarks}}</label>
                      </div>
                    </div>



                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</div>
